import React from 'react';
import Textinput from './textinput';

class SaveViewPopup extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            name: '',
            submitCliked: false,
            nameExist: false
        }

        this.clearForm = this.clearForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSuccess = this.onSuccess.bind(this);

        this.state = this.initialState;
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        let stateProps ={
            [name]: value,
            nameExist: false
        };

        this.setState(stateProps);
    }

    handleSubmit() {
        this.setState({
            ...this.state,
            submitCliked: true,
        });

        let isNameExist = this.props.views.some( view => view.name == this.state.name );

        if (this.state.name) {
            if (isNameExist) {
                this.setState({
                    nameExist: true
                });
            } else {
                let params = {
                  name: this.state.name,
                  args: this.props.marketLogArgs,
                  user_id: this.props.userId,
                  view_type: 'list'
                }
                this.props.saveView('create', params, this.onSuccess);
            }
        }
    }

    onSuccess() {
      this.props.hidePopup();
      this.clearForm();
    }

    closePopup(e) {
        if (e.target.getAttribute('name') == 'saveView') {
            this.props.hidePopup();
            this.clearForm();
        }
    }

    clearForm() {
        this.setState(this.initialState);
    }

	render() {
        let { submitCliked, nameExist, name } = this.state;

        return (
            <div
                onClick={ this.closePopup.bind(this) }
                style={{display: this.props.visible ? 'block' : 'none' }}
                name='saveView'
                className='admin-market-container generic-popup-container'>
                  <div className='admin-market-inner'>
                      <center>
                        <h2 className='title'>
                          Save customised view
                        </h2>
                      </center>

                    <Textinput
                        label='View name'
                        name='name'
                        value={ name || '' }
                        onChange={ this.handleChange }
                        required={true}
                        invalid={(!name || nameExist) && submitCliked}
                        type='text' />

                    {nameExist ?
                        <p className='error'>This name is already exist. Please choose another name.</p>
                    : ''}

                      <button
                        onClick={this.handleSubmit.bind(this)}
                        className='button button-block'>
                        Save
                      </button>
                  </div>
            </div>
        )
    }
}

export default SaveViewPopup;



// WEBPACK FOOTER //
// ./source/components/saveViewPopup.js